import EmbeddedVM from './embedded-vm';
export default {
  init: function(node){
    let vm = new EmbeddedVM();
    console.log('ForumThreadEmbeddedVM initialization function called');
    ko.applyBindingsWithValidation(vm, node);
  }
};
